import { request } from "./httpClient";

function getUrl(prefixKey) {
  const prefix = (window.appConfig && window.appConfig[prefixKey]);
  return process.env.REACT_APP_API_URL + prefix;
}

function createEntityApi(prefixKey) {

  return {

    getData() {
      const timeout = window.appConfig && window.appConfig.getTimeout;
      const url = new URL(getUrl(prefixKey));
      return request(url.toString(), {}, timeout);
    },

    getEntity(entityId) {
      const timeout = window.appConfig && window.appConfig.getTimeout;
      return request(`${getUrl(prefixKey)}${entityId}`, {}, timeout);
    },

    deleteEntity(entityId) {
      const timeout = window.appConfig && window.appConfig.universalTimeout;
      return request(`${getUrl(prefixKey)}${entityId}`, { method: "DELETE" }, timeout);
    },

    addEntity(entity) {
      const timeout = window.appConfig && window.appConfig.universalTimeout;
      return request(
        getUrl(prefixKey),
        {
          method: "POST",
          body: JSON.stringify(entity)
        },
        timeout
      );
    },

    updateEntity(entityId, updateData) {
      const timeout = window.appConfig && window.appConfig.universalTimeout;
      return request(
        `${getUrl(prefixKey)}${entityId}`,
        {
          method: "PATCH",
          body: JSON.stringify(updateData)
        },
        timeout
      );
    },
  };
}

export const electricalSystemsApi = createEntityApi("electricalSystemPrefix");
export const marketContextsApi = createEntityApi("marketContextPrefix");
export const steeringPreferencesApi = createEntityApi("steeringPreferencePrefix");
export const devicesApi = createEntityApi("devicePrefix");
export const sitesApi = {
  ...createEntityApi("sitePrefix"),
  listSteeringPrefs(siteId) {
    const timeout = window.appConfig && window.appConfig.getTimeout;
    return request(`${getUrl("sitePrefix")}${siteId}/steering_preferences`, {}, timeout);
  }
}
export const usersApi = createEntityApi("userPrefix");
export const customersApi = createEntityApi("customerPrefix");
export const edgeVersionsApi = {
  getData: createEntityApi("edgeVersionsPrefix").getData
};